import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Box, Button } from '@mui/material'
import parser from 'html-react-parser'
import { useEffect, useRef, useState } from 'react'
type Props = {
  description?: string
}

export const DescriptionCategory = ({ description }: Props) => {
  const [expanded, setExpanded] = useState(false)
  const [showButton, setShowButton] = useState(false)
  const contentRef = useRef<HTMLDivElement>(null)
  const MAX_HEIGHT = 150

  useEffect(() => {
    if (contentRef.current && contentRef.current.scrollHeight > MAX_HEIGHT) {
      setShowButton(true)
    }
  }, [description])

  if (!description) return null

  return (
    <Box
      sx={{ mt: 4, bgcolor: 'mbgSecond.main', borderRadius: 2, px: 3, pt: 3, pb: 1, position: 'relative' }}
    >
      <Box
        ref={contentRef}
        sx={{
          maxHeight: expanded ? 'none' : MAX_HEIGHT,
          overflow: 'hidden',
          transition: 'max-height 0.3s ease-out',
        }}
        className="common-content"
      >
        {parser(description || '')}
      </Box>

      {!expanded && showButton && (
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '120px',
            background: `linear-gradient(180deg, rgba(233, 233, 233, 0.00) 0%, #E9E9E9 100%)`,
            pointerEvents: 'none',
            borderRadius: '0 0 8px 8px', // Match parent borderRadius
          }}
        />
      )}

      {showButton && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 0.5 }}>
          <Button
            onClick={() => setExpanded(!expanded)}
            endIcon={expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            sx={{
              textTransform: 'none',
              color: 'text.primary',
              fontWeight: 600,
              '&:hover': {
                bgcolor: 'transparent',
                textDecoration: 'underline',
              },
            }}
          >
            {expanded ? 'Thu gọn' : 'Xem thêm'}
          </Button>
        </Box>
      )}
    </Box>
  )
}
